import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import anime from 'animejs';


class Signature extends Component {
  state = {
    signatureShow: '',
    arrowShow: '',
  }

  componentDidMount() {
    // Animated line drawing in SVG https://jakearchibald.com/2013/animated-line-drawing-svg/
    const signaturePaths = this.signatureWriting.children;
    for (let i = 0; i < signaturePaths.length; i++) {
      const path = signaturePaths[i];
      const length = path.getTotalLength();
      path.setAttribute('strokeDasharray', length);
      //path.setAttribute('strokeDashoffset', length);
      path.style.strokeDashoffset = length;
    }

    setTimeout(
      () => {
        anime({
          targets: signaturePaths,
          strokeDashoffset: [anime.setDashoffset, 0],
          easing: 'easeInOutSine',
          duration: 300,
          delay(el, i) { return i * 200; },
          loop: false,
        });
        this.setState({ signatureShow: 'show' });
        if (this.props.location.pathname === '/heyo/') {
          this.delayArrow();
        }
      }
      , 1900); // end setTimeout
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) { // if location changed
      if (this.props.location.pathname === '/heyo/') { // if this page is '/heyo'
        this.delayArrow();
      } else {
        /* eslint-disable react/no-did-update-set-state */
        this.setState({ arrowShow: '' });
        /* eslint-enable react/no-did-update-set-state */
      }
    }
  }

  delayArrow() {
    setTimeout(
      () => {
        this.setState({ arrowShow: 'arrowShow' });
      },
      1300);
  }

  handleClick(e) {
    // disable clicking link if already on that link's destination
    if (this.props.location.pathname === '/') {
      e.preventDefault();
    }
  }

  render() {
    return (
      <Link to="/" className={`signature ${this.state.signatureShow} ${this.state.arrowShow}`} onClick={e => this.handleClick(e)}>
        <span className="signature__inner">

          <span className="visuallyhidden">DAN.</span>
          <svg ref={((el) => { this.signatureWriting = el; })} className="signature__writing" viewBox="0 0 65.9 26.9">
            <path className="signature__path stroke-d1" d="M10.6,8.2c0,0-0.6,4.8-1.1,7.9c-0.5,3.1-1,7.4-1,7.4" />
            <path className="signature__path stroke-d2" d="M1.8,2.2c0,0,4.6-0.8,10.4-0.2s10.6,2.6,10.6,6.5c0,4.7-4.3,9-8.5,12.1c-4.1,3.1-8.9,4.6-8.9,4.6" />
            <path className="signature__path stroke-a1" d="M23.5,22c0,0,4.7-6.1,6.5-9.1c1.9-3.2,3.4-6.5,4.1-7.4c1.4-1.6,1.9,5.3,2.9,9.6c1,4.2,2.2,6.8,3.8,6.8 c1.1,0,1.6-0.3,1.6-0.3" />
            <path className="signature__path stroke-a2" d="M26.2,15.6c0,0,1.9,0.4,4.1,0.4c2.2-0.1,5.4-0.5,5.4-0.5" />
            <path className="signature__path stroke-n1" d="M44.1,16.2c0,0,0-2.8,0.7-6.8c0.4-2.1,0.7-3.7,1.1-3.7c1.4,0,3.4,2.5,5.2,6.5c1.6,3.4,4.6,9.6,5.2,9.6 c0.6,0,0.8-1.4,0.9-3.7S57,5.7,62.4,3.9" />
            <path className="signature__path stroke-period" d="M63.4,21.9c-0.5,0.7,0.4,1.2,0.7,0.9" />
          </svg>

          <span className="signature__fireworks">
            <svg viewBox="0 0 118.9 81.2">
              <defs>
                <path id="circle-3" d="M0,2.5C0,.8.4.1,1.5,0A2.3,2.3,0,0,1,3.3.6a2.3,2.3,0,0,1-.1,1.9C2.8,3.3,1.8,3.3,0,2.5Z" />
                <path id="circle-4" d="M.1,2.5C-.5,1.1,1.2-.3,2.6,0A1.5,1.5,0,0,1,3.7,2C3.4,3.3.8,4,.1,2.5Z" />
                <path id="circle-5" d="M1.9,2.8C.7,2.8,0,2.3,0,1.6S1.2,0,2.3,0A1.5,1.5,0,0,1,3.8,1.6C3.7,2.4,3,2.9,1.9,2.8Z" />
                <path id="circle-6" d="M2.8,1.5c-.1.7-.8.9-1.4,1A1.2,1.2,0,0,1,0,1.1C.2.4.6-.1,1.5,0S2.9.7,2.8,1.5Z" />
                <path id="circle-7" d="M2,0C3,.1,3.6.7,3.5,1.4A1.8,1.8,0,0,1,1.6,2.8,1.9,1.9,0,0,1,0,1C0,.3.7-.1,2,0Z" />
                <path id="circle-8" d="M3.5,1.5A1.5,1.5,0,0,1,1.7,2.7C.9,2.6,0,1.8,0,1.2S1.1-.1,2.2,0,3.6.6,3.5,1.5Z" />
                <path id="circle-2" d="M1.7,3.1C.6,3-.1,2.4,0,1.6S1.4-.1,2.5,0A1.4,1.4,0,0,1,3.7,1.7C3.6,2.7,2.9,3.2,1.7,3.1Z" />
                <path id="circle-1" d="M3.4.2c.7.4.7,2.1-.1,2.4A5.1,5.1,0,0,1,.5,2.5C-.1,2.3-.1,1.6.2,1S2.6-.2,3.4.2Z" />
              </defs>
              <g className="signature__fireworks-1">
                <use transform="translate(77.9 16.1)" xlinkHref="#circle-3" />
                <use transform="translate(88.3 18.4)" xlinkHref="#circle-4" />
                <use transform="translate(96.9 24)" xlinkHref="#circle-5" />
                <use transform="translate(99.3 33.5)" xlinkHref="#circle-6" />
                <use transform="translate(98.4 42.1)" xlinkHref="#circle-7" />
                <use transform="translate(95.1 51.5)" xlinkHref="#circle-8" />
                <use transform="translate(75.9 57.4)" xlinkHref="#circle-2" />
                <use transform="translate(65.6 58.9)" xlinkHref="#circle-3" />
                <use transform="translate(53.8 59.4)" xlinkHref="#circle-4" />
                <use transform="translate(42.8 59.6)" xlinkHref="#circle-5" />
                <use transform="translate(32.6 58.2)" xlinkHref="#circle-6" />
                <use transform="translate(24.3 54.4)" xlinkHref="#circle-7" />
                <use transform="translate(19.5 47.5)" xlinkHref="#circle-8" />
                <use transform="translate(16.5 30.5)" xlinkHref="#circle-2" />
                <use transform="translate(18.3 21.6)" xlinkHref="#circle-3" />
                <use transform="translate(27.8 17.6)" xlinkHref="#circle-4" />
                <use transform="translate(38.1 16.1)" xlinkHref="#circle-5" />
                <use transform="translate(47.9 15.2)" xlinkHref="#circle-6" />
                <use transform="translate(57.2 14.6)" xlinkHref="#circle-7" />
                <use transform="translate(67.4 14.5)" xlinkHref="#circle-8" />
                <use transform="translate(86.4 56.2)" xlinkHref="#circle-1" />
                <use transform="translate(16.4 39.7)" xlinkHref="#circle-1" />
              </g>
              <g className="signature__fireworks-2">
                <use transform="translate(101.9 19.7)" xlinkHref="#circle-8" />
                <use transform="translate(46.4 7.9)" xlinkHref="#circle-3" />
                <use transform="translate(35.7 9.3)" xlinkHref="#circle-2" />
                <use transform="translate(57.3 6.8)" xlinkHref="#circle-4" />
                <use transform="translate(68.4 7.5)" xlinkHref="#circle-5" />
                <use transform="translate(90.2 12.7)" xlinkHref="#circle-7" />
                <use transform="translate(79.4 10.2)" xlinkHref="#circle-6" />
                <use transform="translate(105.7 44.7)" xlinkHref="#circle-2" />
                <use transform="translate(100.1 57.1)" xlinkHref="#circle-3" />
                <use transform="translate(89.2 64.1)" xlinkHref="#circle-4" />
                <use transform="translate(77 66.5)" xlinkHref="#circle-5" />
                <use transform="translate(66 68.5)" xlinkHref="#circle-6" />
                <use transform="translate(53 69.5)" xlinkHref="#circle-7" />
                <use transform="translate(42.7 67.9)" xlinkHref="#circle-8" />
                <use transform="translate(18.9 58.9)" xlinkHref="#circle-2" />
                <use transform="translate(11.7 49.7)" xlinkHref="#circle-3" />
                <use transform="translate(8.3 40.4)" xlinkHref="#circle-4" />
                <use transform="translate(8.6 29.5)" xlinkHref="#circle-5" />
                <use transform="translate(12.5 17.9)" xlinkHref="#circle-6" />
                <use transform="translate(105.9 32.4)" xlinkHref="#circle-1" />
                <use transform="translate(29.7 66.1)" xlinkHref="#circle-1" />
                <use transform="translate(23.9 12.1)" xlinkHref="#circle-1" />
              </g>
              <g className="signature__fireworks-3">
                <use transform="translate(44.7)" xlinkHref="#circle-5" />
                <use transform="translate(93.8 6.3)" xlinkHref="#circle-2" />
                <use transform="translate(115.4 30.5)" xlinkHref="#circle-3" />
                <use transform="translate(108 64.2)" xlinkHref="#circle-6" />
                <use transform="translate(78.9 75.7)" xlinkHref="#circle-7" />
                <use transform="translate(52.3 78.1)" xlinkHref="#circle-2" />
                <use transform="translate(25.9 73.7)" xlinkHref="#circle-4" />
                <use transform="translate(18.4 4.8)" xlinkHref="#circle-4" />
                <use transform="translate(3.9 53.2)" xlinkHref="#circle-6" />
                <use transform="translate(0 27.2)" xlinkHref="#circle-1" />
                <use transform="translate(69.2 0.1)" xlinkHref="#circle-1" />
              </g>
            </svg>
          </span>
          <span className="signature__arrow" />

        </span>
      </Link>
    );
  }
}

Signature.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

export default withRouter(Signature);



// WEBPACK FOOTER //
// ./src/components/Signature.js